import React from 'react';

import CheckCircleIcon from './check-circle-icon';
import {
  CardTitle,
  NumberList,
  ProgressNote,
  ProgressNoteText,
  SectionCard,
} from './project-view.styled';

const PROGRESS_KEPT_TEXT =
  'Your progress stays with you, even if this project closes.';
const ROLE_VERIFIED_TEXT =
  'Your role is already verified. You’ll only need to confirm project details and wait for project review.';

export const SelectionProcessCard: React.FC<{ roleLabel: string }> = ({
  roleLabel,
}) => (
  <SectionCard data-testid="project-selection-process">
    <CardTitle>Selection process</CardTitle>
    <NumberList>
      <li>Send your application and availability.</li>
      <li>
        Complete your profile and verify your {roleLabel ? `${roleLabel} ` : ''}
        role. Existing verification is reused.
      </li>
      <li>
        We review whether you’re a fit for this project and decide on the next
        step.
      </li>
      <li>
        If you’re selected, we send your profile to the client for review.
      </li>
    </NumberList>
  </SectionCard>
);

export const ProjectProgressNote: React.FC<{ roleVerified?: boolean }> = ({
  roleVerified = false,
}) => (
  <ProgressNote data-testid="project-progress-note">
    <CheckCircleIcon />
    <ProgressNoteText>
      {roleVerified ? ROLE_VERIFIED_TEXT : PROGRESS_KEPT_TEXT}
    </ProgressNoteText>
  </ProgressNote>
);
